import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { TranslationService } from './services/translation.service';
// import { faHome } from '@fortawesome/fontawesome-pro-light';
// import { faHomeHeart } from '@fortawesome/fontawesome-pro-solid';
// import { faHospital } from '@fortawesome/fontawesome-pro-regular';
import fontawesome from '@fortawesome/fontawesome';


// import fontawesome from '@fortawesome/fontawesome'
// import solid from '@fortawesome/fontawesome-free-solid'
// import faTwitter from '@fortawesome/fontawesome-free-brands/faTwitter'
// import FontAwesomeIcon from '@fortawesome/vue-fontawesome'

import { library, dom } from '@fortawesome/fontawesome-svg-core';
import { fas, faMoneyBill } from '@fortawesome/free-solid-svg-icons';
import {
  fal,
  faHome,
  faEnvelope,
  faKey,
  faTimes,
  faEdit,
  faFilePdf,
  faUserLock,
  faTrash,
  faCheck,
  faSpinner,
  faDownload,
  faChevronLeft,
  faChevronRight,
  faSearch,
  faExclamationTriangle,
  faExclamationCircle,
  faInfo,
  faFileAlt,
  faEllipsisV,
  faCreditCardBlank,
  faCommentsAlt,
  faFileInvoiceDollar,
  faHandHoldingUsd} from '@fortawesome/pro-light-svg-icons';
import { faHomeHeart, faListAlt, faAngleRight, faTh, faBuilding, faInfoSquare, faBallotCheck } from '@fortawesome/pro-solid-svg-icons';
import {
  faHospital,
  faClipboard,
  faDivide,
  faClone,
  faStream,
  faBan,
  faFilter,
  faInfoCircle,
  faUniversity,
  faThumbsUp,
  faBars,
  faBookmark,
  faBook,
  faCommentAlt,
  faHandHoldingHeart,


 } from '@fortawesome/pro-regular-svg-icons';
import { faTwitter } from '@fortawesome/free-brands-svg-icons';
// import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.sass']
})
export class AppComponent implements OnInit {
  title = 'app';
  public tablesTranslate: any;
  constructor(
    private _translation: TranslationService,
    private _translate: TranslateService,
  ) {
    // fontawesome.library.add(faHome, faHomeHeart, faHospital);
    library.add(
      fas,
      fal,
      faTwitter,
      faHome,
      faHomeHeart,
      faHospital,
      faEnvelope,
      faKey,
      faTimes,
      faEdit,
      faFilePdf,
      faUserLock,
      faTrash,
      faCheck,
      faSpinner,
      faDownload,
      faChevronLeft,
      faChevronRight,
      faSearch,
      faExclamationTriangle,
      faInfo,
      faClipboard,
      faDivide,
      faClone,
      faStream,
      faBan,
      faFilter,
      faInfoCircle,
      faUniversity,
      faMoneyBill,
      faCreditCardBlank,
      faExclamationCircle,
      faBook,
      faFileAlt,
      faBookmark,
      faInfoSquare,
      faEllipsisV,
      faBars,
      faListAlt,
      faAngleRight,
      faThumbsUp,
      faTh,
      faBuilding,
      faBallotCheck,
      faCommentAlt,
      faCommentsAlt,
      faFileInvoiceDollar,
      faHandHoldingHeart,
      faHandHoldingUsd
      );

    // Kicks off the process of finding <i> tags and replacing with <svg>
    dom.watch();
  }
  ngOnInit() {
    this.initializeDatablesTranslation();
  }

  initializeDatablesTranslation(): void {
    this._translation.getDataTableTranslation()
      .subscribe(dataTableTranslation => {
        this.tablesTranslate = dataTableTranslation;
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts